import styled from '@emotion/styled';
import CreditScoreIcon from '@portalterreno/react-ui-icons/CreditScoreIcon';

const Icon = styled(CreditScoreIcon)({
  width: '24px',
  height: '24px',
  color: '#0068ff'
});

export default Icon;
